import { render, staticRenderFns } from "./ProgrammedActivityCard.vue?vue&type=template&id=a8571012&scoped=true&"
import script from "./ProgrammedActivityCard.vue?vue&type=script&lang=js&"
export * from "./ProgrammedActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammedActivityCard.vue?vue&type=style&index=0&id=a8571012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8571012",
  null
  
)

export default component.exports